import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import i18nBackend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"
import { getTgUser } from "@/helpers/tgWebApp"

export const languagePresets = {
  en: ["en", "en-US"],
  // CIS locales fall back to Russian. These are LANGUAGE codes — the form both
  // navigator.language and Telegram's user.language_code emit — NOT country
  // codes: be=Belarus, kk=Kazakhstan, ky=Kyrgyzstan, tg=Tajikistan,
  // uz=Uzbekistan, az=Azerbaijan, hy=Armenia, ro=Moldova (note: ro also =
  // Romania, which will therefore resolve to ru as well).
  ru: ["ru", "ru-RU", "be", "kk", "ky", "tg", "uz", "az", "hy", "ro"],
  uk: ["uk", "uk-UA"]
}

const getFallbackLanguages = (lng: string) => {
  let lang = "en"

  Object.entries(languagePresets).forEach(([key, values]) => {
    if (values.includes(lng)) {
      lang = key
    }
  })

  return lang
}

// Custom detector: inside a Telegram WebApp the authoritative language is the
// user's Telegram UI language (`user.language_code`), NOT navigator.language —
// in the in-app webview navigator reflects the device OS locale, not the
// Telegram interface. Null-safe (getTgUser is window?.Telegram?...): returns
// undefined outside Telegram, so the chain falls through to navigator.
const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: "telegram",
  lookup: () => getTgUser()?.language_code
})

i18n.on("languageChanged", (lng) => {
  const lang = getFallbackLanguages(lng)

  document.documentElement.lang = lang
})

i18n
  .use(languageDetector)
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/localization/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_LOCALIZATION_VERSION}`
    },
    defaultNS: "common",
    ns: ["common", "catalog"],
    fallbackLng: (lng) => getFallbackLanguages(lng),
    supportedLngs: ["en", "ru", "uk"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "telegram", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"]
    },
    react: {
      useSuspense: false
    },
    debug: import.meta.env.VITE_NODE_ENV !== "production",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
